import * as api from "services/api";
import ls from "Localization";

export const GET_TAG_COLORS = "[TAG COLOR] GET_TAG_COLORS";
export const GET_TAG_COLORS_FAILED = "[TAG COLOR] GET_TAG_COLORS_FAILED";
export const GET_TAG_COLORS_SUCCESS = "[TAG COLOR] GET_TAG_COLORS_SUCCESS";

export const DELETE_TAG_COLOR = "[TAG COLOR] DELETE_TAG_COLOR";
export const DELETE_TAG_COLOR_FAILED = "[TAG COLOR] DELETE_TAG_COLOR_FAILED";
export const DELETE_TAG_COLOR_SUCCESS = "[TAG COLOR] DELETE_TAG_COLOR_SUCCESS";

export const SET_VALUE = "[TAG COLOR] SET_VALUE";
export const CLEAR_VALUE = "[TAG COLOR] CLEAR_VALUE";

export function getTagColors() {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_TAG_COLORS
		});

		const { token } = getState().login;

		let response = await api.sendGet("/TagColor", {
			Authorization: "Bearer " + token
		});

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: GET_TAG_COLORS_SUCCESS,
				payload: json.model
			});
		} else {
			dispatch({ type: GET_TAG_COLORS_FAILED });
		}
	};
}

export function getTagColorsV2(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_TAG_COLORS
		});

		const { login } = getState();
		const { token } = login;

		let response = await api.sendGet(
			`/TagColor/v2?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter || ""}`,
			{
				Authorization: "Bearer " + token
			}
		);

		if (response.ok) {
			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_TAG_COLORS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				dispatch({ type: GET_TAG_COLORS_FAILED, payload: result.errors });
				callback && callback(result.errors, result.model);
			}
		} else {
			dispatch({ type: GET_TAG_COLORS_FAILED });
			callback && callback("Ocorreu um erro ao tentar carregar as cores de etiqueta");
		}
	};
}

export function deleteTagColor(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: DELETE_TAG_COLOR
		});

		const { token } = getState().login;
		const { items } = getState().tagColor;

		api
			.sendDelete("/TagColor/" + id, {
				Authorization: "Bearer " + token
			})
			.then(res => {
				if (res.ok) {
					return res.json();
				}

				if (res.status === 409) {
					return res.json();
				}
			})
			.then(result => {
				if (result && result.isValid) {
					dispatch({
						type: DELETE_TAG_COLOR_SUCCESS,
						payload: items.filter(i => i.id !== id)
					});

					callback && callback();
				} else if (result && result.errors) {
					let errors = "";

					for (const error of result.errors) {
						const err = ls[error];

						if (err) errors += err + ",";
						else errors += error + ",";
					}

					errors = errors.substr(0, errors.length - 1);

					dispatch({ type: DELETE_TAG_COLOR_FAILED, payload: errors });

					callback && callback(errors);
				}
			});
	};
}

export function getNextTagNumber(colorId) {
	return async (dispatch, getState) => {
		const { login } = getState();
		const res = await api.sendGet(`/TagColor/${colorId}/next-number`, {
			Authorization: "Bearer " + login.token
		});
		if (res.ok) {
			const json = await res.json();
			if (json.isValid) return json.model; // integer
		}
		return 1; // safe fallback; staff can override
	};
}

export function setValue(payload) {
	return {
		type: SET_VALUE,
		payload
	};
}

export function clearValue() {
	return {
		type: CLEAR_VALUE
	};
}
